import { useRecoilState } from 'recoil';
import { aDirectMemoComposerUserIds, aMemoComposerUserIds } from 'shared-state/messaging/atoms';

export const useMessageComposerUserIds = (): any => useRecoilState(aMemoComposerUserIds);
export const useDirectMessageComposerUserIds = (): any => useRecoilState(aDirectMemoComposerUserIds);
